"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Prompt = void 0;
// 弱提示弹窗
var react_1 = __importStar(require("react"));
var tools_1 = require("../../utils/tools");
var WithErrorHandler_1 = require("../WithErrorHandler");
var timer;
var Prompt = function (props) {
    var clearTimer = function () {
        // 清除倒计时
        if (timer) {
            clearTimeout(timer);
        }
    };
    var showFun = function () {
        // 显示
        if (typeof props.closingTime != 'undefined') {
            timer = setTimeout(function () {
                tools_1.autoClick();
            }, props.closingTime * 1000);
        }
        // 点击任意区域 隐藏若提示
        setTimeout(function () {
            tools_1.once(document, 'click', function () {
                if (props.show) {
                    clearTimer();
                    if (typeof props.closeFun != 'undefined' &&
                        Object.prototype.toString
                            .apply(props.closeFun)
                            .toLocaleLowerCase()
                            .indexOf('function') != -1) {
                        props.closeFun();
                    }
                }
            });
        }, 100);
    };
    react_1.useEffect(function () {
        clearTimer();
        if (props.show) {
            showFun();
        }
        return function () {
            clearTimer();
        };
    }, [props.show]);
    return (react_1.default.createElement("div", { className: "newcar_ui_prompt " + props.cn + " " + (props.show ? 'newcar_ui_showPrompt' : '') }, props.tipStr));
};
exports.Prompt = Prompt;
exports.Prompt.defaultProps = {
    show: false,
    tipStr: '',
    cn: '',
    closingTime: 3,
    // eslint-disable-next-line no-empty-function
    closeFun: function () { }
};
exports.default = WithErrorHandler_1.WithErrorHandler(react_1.memo(exports.Prompt));
